import { useQuery } from "@tanstack/react-query";
import authAPI from "../../api/auth/api";

export function getQueryKey() {
  return ["auth", "current-user"];
}

export function useGetCurrentUser() {
  return useQuery({
    queryKey: ["auth", "current-user"],
    queryFn: authAPI.getCurrentUser,
    retry: false,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
